export default __webpack_public_path__ + "static/media/now-you-try.fbdfa000.mp3";